import { TJob } from './isJob';

export default function jobProduct(job: Pick<TJob, 'treatments'>): string {
	return job.treatments.length
		? job.treatments
				.map((treatment) => treatment.originalProduct?.name)
				.join(', ')
		: '-';
}
